// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox, Radio, RadioGroup,
} from 'informed';
import NumericText from '../../../NumericText.jsx';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  sensory: Object,
}

class ViewSensory extends Component<Props> {
  render() {
    const sensory = this.props.sensory || {};
    return (
      <ContentBox title='Sensory'>
        <div className={styles.col}>
          <PrimaryText>Vision Assessment:</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox disabled field='sensory.noVisionProblems' initialValue={sensory.noVisionProblems} />No major vision problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox disabled field='sensory.visionWorsening' initialValue={sensory.visionWorsening} />Vision problems worsening<br />
            <Checkbox disabled field='sensory.difficultyAtNight' initialValue={sensory.difficultyAtNight} />Difficulty seeing at night<br />
            <Checkbox disabled field='sensory.rightEyePain' initialValue={sensory.rightEyePain} />Right eye pain<br />
            <Checkbox disabled field='sensory.leftEyePain' initialValue={sensory.leftEyePain} />Left eye pain<br />
            <Checkbox disabled field='sensory.bilateralEyePain' initialValue={sensory.bilateralEyePain} />Bilateral eye pain<br />
            <Checkbox disabled field='sensory.blurredVision' initialValue={sensory.blurredVision} />Blurred vision<br />
            <Checkbox disabled field='sensory.halosVision' initialValue={sensory.halosVision} />Halos in vision<br />
            <Checkbox disabled field='sensory.blindSpots' initialValue={sensory.blindSpots} />Blind spots<br />
            <Checkbox disabled field='sensory.legalBlind' initialValue={sensory.legalBlind} />Legal blindness<br />
            <Checkbox disabled field='sensory.blindnessLeft' initialValue={sensory.blindnessLeft} />Blindness in left eye<br />
            <Checkbox disabled field='sensory.blindnessRight' initialValue={sensory.blindnessRight} />Blindness in right eye<br />
            <Checkbox disabled field='sensory.prosthesisLeft' initialValue={sensory.prosthesisLeft} />Prosthesis, left orbit<br />
            <Checkbox disabled field='sensory.prosthesisRight' initialValue={sensory.prosthesisRight} />Prosthesis, right orbit<br />
            <Checkbox disabled field='sensory.enuclearLeft' initialValue={sensory.enuclearLeft} />Enuclear, left orbit<br />
            <Checkbox disabled field='sensory.enuclearRight' initialValue={sensory.enuclearRight} />Enuclear, right orbit
          </div>
          <div className={styles.section}>
            <Checkbox disabled field='sensory.wearsGlasses' initialValue={sensory.wearsGlasses} />Wears glasses<br />
            <Checkbox disabled field='sensory.wearsContacts' initialValue={sensory.wearsContacts} />Wears contacts
          </div>
          <div className={styles.section}>
            <SecondaryText>Vision notes:</SecondaryText><br />
            <TextArea disabled field='sensory.visionNotes' initialValue={sensory.visionNotes} />
          </div>
          <PrimaryText>Hearing Assessment</PrimaryText><br />
          <div className={styles.section}>
            <Checkbox disabled field='sensory.noHearingProblems' initialValue={sensory.noHearingProblems} />No hearing problems noted
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox disabled field='sensory.hearingWorsening' initialValue={sensory.hearingWorsening} />Hearing problems worsening<br />
            <Checkbox disabled field='sensory.difficultHearing' initialValue={sensory.difficultHearing} />Difficulty hearing<br />
            <Checkbox disabled field='sensory.hearingAidRight' initialValue={sensory.hearingAidRight} />Hearing aid, right ear<br />
            <Checkbox disabled field='sensory.hearingAidLeft' initialValue={sensory.hearingAidLeft} />Hearing aid, left ear<br />
            <Checkbox disabled field='sensory.implantRight' initialValue={sensory.implantRight} />Cochlear implant, right ear<br />
            <Checkbox disabled field='sensory.implantLeft' initialValue={sensory.implantLeft} />Cochlear implant, left ear<br />
            <Checkbox disabled field='sensory.refusesHearingAid' initialValue={sensory.refusesHearingAid} />Needs hearing aid but refuses<br />
            <Checkbox disabled field='sensory.deaf' initialValue={sensory.deaf} />Deaf
          </div>
          <div className={styles.section}>
            <SecondaryText>Hearing notes:</SecondaryText><br />
            <TextArea disabled field='sensory.hearingNotes' initialValue={sensory.hearingNotes} />
          </div>
          <PrimaryText>Pupils</PrimaryText><br />
          <PrimaryText>Pupillary Equality</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Bilateral assessment:</SecondaryText><br />
            <table>
              <tbody className={styles.topAlign}>
                <tr>
                  <td><SecondaryText>Equal?</SecondaryText></td>
                  <td>
                    <RadioGroup field='sensory.pupilEqual' initialValue={sensory.pupilEqual}>
                      <Radio disabled value='yes' />Yes<br />
                      <Radio disabled value='no' />No
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td><SecondaryText>Round?</SecondaryText></td>
                  <td>
                    <RadioGroup field='sensory.pupilRound' initialValue={sensory.pupilRound}>
                      <Radio disabled value='yes' />Yes<br />
                      <Radio disabled value='no' />No
                    </RadioGroup>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <PrimaryText>Size</PrimaryText><br />
          <div className={styles.section}>
            <table>
              <tbody>
                <tr>
                  <td><SecondaryText>Left pupil:</SecondaryText></td>
                  <td><NumericText field='sensory.pupilLeftSize' initialValue={sensory.pupilLeftSize} size={4} /></td>
                  <td> mm</td>
                </tr>
                <tr>
                  <td><SecondaryText>Right pupil:</SecondaryText></td>
                  <td><NumericText field='sensory.pupilRightSize' initialValue={sensory.pupilRightSize} size={4} /></td>
                  <td> mm</td>
                </tr>
              </tbody>
            </table>
          </div>
          <PrimaryText>Pupillary Reaction</PrimaryText><br />
          <div className={styles.section}>
            <SecondaryText>Left eye reaction to light:</SecondaryText><br />
            <RadioGroup field='sensory.leftEyeReaction' initialValue={sensory.leftEyeReaction}>
              <Radio disabled value='brisk' />Brisk<br />
              <Radio disabled value='sluggish' />Sluggish<br />
              <Radio disabled value='no response' />No response<br />
              <Radio disabled value='blown' />Blown
            </RadioGroup>
            <br />
            <br />
            <Checkbox disabled field='sensory.leftEyeConst' initialValue={sensory.leftEyeConst} />Constricted<br />
            <Checkbox disabled field='sensory.leftEyeDilate' initialValue={sensory.leftEyeDilate} />Dilated
          </div>
          <div className={styles.section}>
            <SecondaryText>Right eye reaction to light:</SecondaryText><br />
            <RadioGroup field='sensory.rightEyeReaction' initialValue={sensory.rightEyeReaction}>
              <Radio disabled value='brisk' />Brisk<br />
              <Radio disabled value='sluggish' />Sluggish<br />
              <Radio disabled value='no response' />No response<br />
              <Radio disabled value='blown' />Blown
            </RadioGroup>
            <br />
            <br />
            <Checkbox disabled field='sensory.rightEyeConst' initialValue={sensory.rightEyeConst} />Constricted<br />
            <Checkbox disabled field='sensory.rightEyeDilate' initialValue={sensory.rightEyeDilate} />Dilated
          </div>
          <PrimaryText>Pupillary Accommodation</PrimaryText><br />
          <div className={styles.section}>
            Positive evaluation requires two findings: bilateral pupillary constriction and convergency of axis of eyes.<br />
            <SecondaryText>Accommodation present?</SecondaryText><br />
            <RadioGroup field='sensory.accommodation' initialValue={sensory.accommodation}>
              <Radio disabled value='yes' />Yes<br />
              <Radio disabled value='no' />No
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Pupil notes:</SecondaryText><br />
            <TextArea disabled field='sensory.pupilNotes' initialValue={sensory.pupilNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default ViewSensory;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/view/ViewSensory.jsx